import {Client} from '@/store/modules/clients/types'

export const initClient: ClientFormData = {
  clientType: '1',
  name: '',
  bizRegistrationNumber: '',
  ownerName: '',
  fullAddress: '',
  businessType: '',
  businessClass:'',
  taxRegistrationNumber: '',
  phoneNumber: '',
  email: '',
  emailSub: '',
  sales: null,
}

export interface ClientFormData extends Omit<Client, 'id' | 'isCorporate'> {
  clientType: '1'
}
